/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react';
import { PortalFrame } from 'components/PortalFrame';
import { useData } from '../Data';
import { ResearchMenu } from './Menu';
//import { ResearchList } from './List';
//import { ResearchDetails } from './Details';
import { BreadCrumb } from './BreadCrumb';
import { TeachingTop } from './TeachingTop';
import { TeachingSemester } from './TeachingSemester';
import { TeachingCourse } from './TeachingCourse';
import { CourseDataProvider } from './CourseData';

type TeachingRootProps = {
  sidecolumn: any;
  breadcrumb: any;
};
export function TeachingRoot(props: TeachingRootProps) {
  const { current, urls } = useData();
  const [current_semester, current_course] = current ?? [null, null];
  return (<React.Fragment>
    <PortalFrame root={BreadCrumb} node={props.breadcrumb} />
    <PortalFrame root={ResearchMenu} node={props.sidecolumn} />
    {
      (!current_semester && !current_course) && <TeachingTop /> ||
        <CourseDataProvider urls={urls} semester={current_semester}>
          {
            (current_semester  && !current_course) && <TeachingSemester /> ||
            (current_semester && current_course) && <TeachingCourse />
          }
        </CourseDataProvider>
    }
  </React.Fragment>);
}
